module.exports = __webpack_public_path__ + "static/servicios_2-81037c374c6a597487411eb359d251ac.jpg";